<script lang="ts">
	// Svelte hooks
	import { createEventDispatcher } from 'svelte';
	// Types
	import type { EventsLogData } from 'src/types/requests/eventslog/events_log';
	// Components
	import IconForInputReader from './IconForInputReader.svelte';
	import CameraEventExpanded from './CameraEventExpanded.svelte';
	// Design system components
	import { Container, Icon, Modal, Text } from '@Shelly/shelly-design-system';
	// Helpers
	import { timestampToDate } from 'src/helpers/date_helper';
	import {
		eventLogHasRecordingExpand,
	} from './event_log_helper';
	import {
		getEventPropertyLabel,
		openEventSidePanel,
	} from './event_log_v2_ui_helpers';

	const dispatch = createEventDispatcher();

	export let event: EventsLogData = null;
	export let labelList: any[] = [];
	export let showModal = false;
	export let isMobile = false;

	/** Input reader events carry an object instead of an icon class name. */
	$: statusIcon = event?.icon?.icon as string | { value: string };

	$: hasRecording = Boolean(event) && eventLogHasRecordingExpand(event);

	const closeModal = () => {
		dispatch('close');
	};

	const openEntitySidePanel = () => {
		const selectedEvent = event;

		closeModal();
		openEventSidePanel(selectedEvent);
	};
</script>

<Modal {showModal} hideTitle on:close={closeModal}>
	<Container slot="content" padding="0">
		{#if event}
			<div class="d-flex align-items-center mb-m">
				{#if statusIcon}
					<div class="mr-s d-flex align-items-center">
						{#if typeof statusIcon === 'string'}
							<Icon icon={statusIcon} size="l" style={event.icon?.style} />
						{:else}
							<IconForInputReader event={statusIcon.value} />
						{/if}
					</div>
				{/if}

				<div class="d-flex flex-direction-column">
					<Text
						class="link-styles text-bold"
						styleType="controls-large"
						breakWord
						on:click={openEntitySidePanel}
					>
						{event.name}
					</Text>
					{#if event.room}
						<Text class="text-secondary" styleType="body-small" breakWord>
							{event.room}
						</Text>
					{/if}
				</div>
			</div>

			<div class="d-flex align-items-center mb-m">
				<Icon class="mr-xs" icon="fas fa-calendar" size="s" />
				<Text styleType="body-small">{timestampToDate(event.timestamp)}</Text>
			</div>

			{#if hasRecording || labelList.length}
				<div class="event-details-divider mb-m"></div>
			{/if}

			{#if hasRecording}
				<CameraEventExpanded {event} {isMobile} />
			{/if}

			{#if labelList.length}
				<div class="d-flex flex-direction-column">
					{#each labelList as property (property.name)}
						<div class="d-flex align-items-center mb-xs">
							{#if property.icon}
								<div class="mr-xs d-flex align-items-center">
									{#if typeof property.icon === 'string'}
										<Icon icon={property.icon} size="s" style={property.iconStyle} />
									{:else}
										<IconForInputReader event={property.icon.value} />
									{/if}
								</div>
							{/if}
							<Text styleType="body-small">{getEventPropertyLabel(property)}</Text>
						</div>
					{/each}
				</div>
			{/if}
		{/if}
	</Container>
</Modal>

<style>
	.event-details-divider {
		height: 1px;
		background-color: var(--color-2);
	}
</style>
